import type { QueryClient, QueryKey } from '@tanstack/react-query';

import { codeSessionKeys } from './queries';
import { codeSessionWorkspaceKeys } from './workspace-keys';

async function refreshWorkspaceKey(client: QueryClient, queryKey: QueryKey) {
  // Even an initial read can predate a commit or completed turn. Cancel it
  // before invalidating so it cannot satisfy the refresh with stale contents.
  await client.cancelQueries({ queryKey });
  await client.invalidateQueries({ queryKey });
}

export function refreshSessionWorkspace(client: QueryClient, sessionId: string) {
  return refreshWorkspaceKey(client, codeSessionWorkspaceKeys.all(sessionId));
}

export function refreshSessionGit(client: QueryClient, sessionId: string) {
  return refreshWorkspaceKey(client, codeSessionWorkspaceKeys.git(sessionId));
}

/** An explicit retry may need to wake a stopped sandbox before reading workspace data. */
export async function resumeSessionWorkspace(client: QueryClient, sessionId: string) {
  try {
    await client.refetchQueries(
      { queryKey: codeSessionKeys.detail(sessionId), exact: true, type: 'active' },
      { throwOnError: true },
    );
  } finally {
    // A stopped VM can become ready without a status transition in saved data.
    // Always refresh preview queries after the detail request settles.
    await refreshSessionWorkspace(client, sessionId);
  }
}
